/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import { Checkbox } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  dispatchClaimAuditDetail,
  dispatchClaimAuditDetailTabData,
  dispatchClaimAuditSelectTabData,
  dispatchErrorMsgForClaimAudit,
  getAllLabelerData,
  getClaimAuditDetailData,
  getClaimAuditPopupCountDataApi,
  getClaimCategoryCodeTable,
  getExportAllDetail,
  getFreezeQuarterForClaimAudit,
  getRebateProgramDataMD,
  getSpecificAuditTypeData,
  setChangesDataList,
  dispatchPageCountwithDetails,
  setExportHandler,
} from '../store/actions';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  redirectURLLink,
  compareQtrs,
  checkQuarterValidation,
  isDateToQuarter,
  isCheckDateFormat,
  lowerCaseAllWordsExceptFirstLetters,
  upperCaseFirstLetter,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { SelectByLabelerColoumData } from './gridComponent/TableHeaders';
import {
  STATUS_MSG,
  SUCCESS_MSG,
  FROM_DATE_QTR_REQUIRED,
  TO_DATE_QTR_REQUIRED,
  REBATE_PROGRAM_REQUIRED,
  MNFC_NDC_ERROR_MSG,
  TO_DATE_CANT_BE_LESS_THAN_FROM,
  TO_QTR_CANT_BE_LESS_THAN_FROM,
  FROZEN_INVOICE_FOR_LESS_THAN_TEN,
  FROZEN_INVOICES_GREATER_THAN_TEN,
  DATE_QTR_VALIDATION,
  NDC_LIMIT_TO_1000,
  API_TIMEOUT_ERROR,
  FAILED_MESSAGE_GENERIC,
} from '../../../../SharedModules/Errors/constantMessageData';
import SearchTypeComponent from '../../../../SharedModules/SearchTypeComponent/SearchTypeComponent';
import {
  amountAuditLabel,
  auditTypeLabel,
  includeClearedAuditsLabel,
  labelerGridFileName,
  navigate,
  otherAuditsLabel,
  rebateProgramLable,
  reversedLable,
  selectByLabel,
  showMyAuditsOnlyLable,
  textFieldLabelFrom,
  textFieldLabelTo,
  unitConversionAuditsLabel,
  unreversedLable,
  viewClaimDetailButton,
} from './ConstantData';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../SharedModules/DateUtilities/DateUtilities';

const ClaimAuditSelect = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  // use Selector function
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const searchClaimAuditSelectData = useSelector(
    (state) => state?.sharedState?.ClaimAuditReducer?.claimAuditSelectScreenData
  );
  const labelerList = useSelector(
    (state) => state?.sharedState?.ClaimAuditReducer?.labelerList
  );
  const getRebateProgramListData = useSelector(
    (state) => state?.sharedState?.ClaimAuditReducer?.rebateProgram
  );
  const getSpecificAuditTypeListData = useSelector(
    (state) => state?.sharedState?.ClaimAuditReducer?.speAuditType
  );
  const getErrorMsg = useSelector(
    (state) => state?.sharedState?.ClaimAuditReducer?.errorMsgCAudit
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  // variable deceleration
  const errorMessagesOfSearchTypeComp =
    getErrorMsg?.searchScreenErrors?.length > 0
      ? _.filter(
          getErrorMsg?.searchScreenErrors,
          (l) => l?.errorComponent === 'searchTypeComponent' && l.message
        ).map((val) => val)
      : [];
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [count, setCount] = React.useState(0);
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [labelerListDataList, setLabelerListDataList] = React.useState([]);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [rebateProgListMD, setRebateProgListMD] = React.useState([]);
  const [rebateProgListST, setRebateProgListST] = React.useState([]);
  const [rebateProgListCOMM, setRebateProgListCOMM] = React.useState([]);
  const [claimAuditDetailData, setClaimAuditDetailData] = React.useState();
  const [specificAuditTypeList, setSpecificAuditTypeList] = React.useState([]);
  const [gridApi, setGridApi] = React.useState(null);

  const [openModal, setOpenModal] = React.useState(false);
  const [selectedData, setSelectedData] = React.useState([]);
  const [payloadForDetailAPI, setPayloadForDetailAPI] = React.useState(null);

  const searchCompObj = searchClaimAuditSelectData?.searchData?.searchTypeState;
  const [searchData, setSearchData] = React.useState(
    searchClaimAuditSelectData?.searchData
      ? searchClaimAuditSelectData?.searchData
      : {
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? userDefaults?.rebateProgramCd
            : '-1',
          paidDateRangeFrom: '',
          paidDateRangeTo: '',
          myAuditOnly: false,
          fromDateRangeForMyAudit: '',
          toDateRangeForMyAudit: '',
          unreversed: 1,
          reversed: 0,
          clearAudit: 0,
          selectBy: 'A',
          auditType: 'ALL',
          amountAudit: 0,
          unitConversionAudit: 0,
          otherAudit: 0,
          speAuditType: '',
          searchTypeState: {
            valueSelectedRedux: 'NDC',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
            ndcLeftSelectedRowsRedux: [],
            ndcRightSelectedRowsRedux: [],
            labelerSelectedRowRedux: '',
            ndcLeftFullScreenRedux: false,
            ndcRightFullScreenRedux: false,
            labelerFullScreenRedux: false,
          },
        }
  );

  const [searchType, setSearchType] = React.useState(
    searchCompObj?.valueSelectedRedux
      ? searchCompObj?.valueSelectedRedux
      : userDefaults?.defNdcSelectModeCd
      ? userDefaults?.defNdcSelectModeCd === 'NDC'
        ? 'NDC'
        : upperCaseFirstLetter(
            lowerCaseAllWordsExceptFirstLetters(
              userDefaults?.defNdcSelectModeCd
            )
          )
      : 'NDC'
  );
  const [labelerFullScreen, setLabelerFullScreen] = React.useState(
    searchCompObj?.labelerFullScreenRedux
      ? searchCompObj?.labelerFullScreenRedux
      : false
  );
  const [ndcLeftFullScreen, setNdcLeftFullScreen] = React.useState(
    searchCompObj?.ndcLeftFullScreenRedux
      ? searchCompObj?.ndcLeftFullScreenRedux
      : false
  );
  const [ndcRightFullScreen, setNdcRightFullScreen] = React.useState(
    searchCompObj ? searchCompObj.ndcRightFullScreenRedux : false
  );
  const [labelerSelectedRow, setlabelerSelectedRow] = React.useState(
    searchCompObj?.labelerSelectedRowRedux
      ? searchCompObj?.labelerSelectedRowRedux
      : ''
  );
  const [ndcLeftSelectedRows, setNdcLeftSelectedRows] = React.useState(
    searchCompObj?.ndcLeftSelectedRowsRedux
      ? searchCompObj?.ndcLeftSelectedRowsRedux
      : []
  );
  const [ndcRightSelectedRows, setNdcRightSelectedRows] = React.useState(
    searchCompObj?.ndcRightSelectedRowsRedux
      ? searchCompObj?.ndcRightSelectedRowsRedux
      : []
  );
  const [labelerTableData, setlabelerTableData] = React.useState(
    searchCompObj?.labelerTableDataRedux
      ? searchCompObj?.labelerTableDataRedux
      : []
  );
  const [ndcLeftTableData, setNdcLeftTableData] = React.useState(
    searchCompObj?.ndcLeftTableDataRedux
      ? searchCompObj?.ndcLeftTableDataRedux
      : []
  );
  const [ndcRightTableData, setNdcRightTableData] = React.useState(
    searchCompObj?.ndcRightTableDataRedux
      ? searchCompObj?.ndcRightTableDataRedux
      : []
  );
  const [ndcSearchVal, setNdcSearchVal] = React.useState(
    searchCompObj?.ndcSearchTextRedux ? searchCompObj?.ndcSearchTextRedux : ''
  );
  const [ndcNameSearchVal, setNdcNameSearchVal] = React.useState(
    searchCompObj?.ndcNameSearchTextRedux
      ? searchCompObj?.ndcNameSearchTextRedux
      : ''
  );
  const [errorMsgFromSearchType, setErrorMsgFromSearchType] = React.useState(
    errorMessagesOfSearchTypeComp
  );
  // dispatch function
  const setSearhClaimAuditData = (value) => {
    dispatch(dispatchClaimAuditSelectTabData(value));
  };
  // handling refreshfunctionality for fullscreen view
  React.useEffect(() => {
    const searchObj = {
      valueSelectedRedux: searchType || 'NDC',
      ndcSearchTextRedux: ndcSearchVal || '',
      ndcNameSearchTextRedux: ndcNameSearchVal || '',
      ndcLeftTableDataRedux: ndcLeftTableData || [],
      ndcRightTableDataRedux: ndcRightTableData || [],
      labelerTableDataRedux: labelerTableData || [],
      ndcLeftSelectedRowsRedux: ndcLeftSelectedRows || [],
      ndcRightSelectedRowsRedux: ndcRightSelectedRows || [],
      labelerSelectedRowRedux: labelerSelectedRow || '',
      labelerFullScreenRedux: labelerFullScreen,
      ndcLeftFullScreenRedux: ndcLeftFullScreen,
      ndcRightFullScreenRedux: ndcRightFullScreen,
    };
    setSearchData({ ...searchData, searchTypeState: searchObj });
    setSearhClaimAuditData({
      ...searchClaimAuditSelectData,
      searchData: { ...searchData, searchTypeState: searchObj },
    });
  }, [
    searchType,
    labelerSelectedRow,
    ndcLeftSelectedRows,
    ndcRightSelectedRows,
    labelerTableData,
    ndcLeftTableData,
    ndcRightTableData,
    ndcSearchVal,
    ndcNameSearchVal,
    labelerFullScreen,
    ndcLeftFullScreen,
    ndcRightFullScreen,
  ]);
  // handing full screen view
  React.useEffect(() => {
    if (labelerFullScreen || ndcLeftFullScreen || ndcRightFullScreen) {
      setFullScreenView(true);
      const searchObj = {
        valueSelectedRedux: searchType || 'NDC',
        ndcSearchTextRedux: ndcSearchVal || '',
        ndcNameSearchTextRedux: ndcNameSearchVal || '',
        ndcLeftTableDataRedux: ndcLeftTableData || [],
        ndcRightTableDataRedux: ndcRightTableData || [],
        labelerTableDataRedux: labelerTableData || [],
        ndcLeftSelectedRowsRedux: ndcLeftSelectedRows || [],
        ndcRightSelectedRowsRedux: ndcRightSelectedRows || [],
        labelerSelectedRowRedux: labelerSelectedRow || '',
        labelerFullScreenRedux: labelerFullScreen,
        ndcLeftFullScreenRedux: ndcLeftFullScreen,
        ndcRightFullScreenRedux: ndcRightFullScreen,
      };

      setSearhClaimAuditData({
        ...searchClaimAuditSelectData,
        fullScreenView: true,
        searchData: { ...searchData, searchTypeState: searchObj },
      });
    } else {
      setFullScreenView(false);
      setSearhClaimAuditData({
        ...searchClaimAuditSelectData,
        fullScreenView: false,
        searchData: searchData,
      });
    }
  }, [labelerFullScreen, ndcLeftFullScreen, ndcRightFullScreen]);
  // payload variable from Date field

  React.useEffect(() => {
    if (
      searchClaimAuditSelectData &&
      Object.keys(searchClaimAuditSelectData).length === 0
    ) {
      dispatch(
        dispatchErrorMsgForClaimAudit({
          // searchScreenErrors: [],
          detailScreenErrors: getErrorMsg?.detailScreenErrors
            ? getErrorMsg?.detailScreenErrors
            : [],
        })
      );
    } else if (searchClaimAuditSelectData?.fullScreenView) {
      setFullScreenView(searchClaimAuditSelectData.fullScreenView);
    }
    dispatch(getClaimCategoryCodeTable());
  }, []);
  const adtFrom =
    searchData?.myAuditOnly === false || searchData?.myAuditOnly === 0
      ? searchData?.paidDateRangeFrom
      : searchData?.fromDateRangeForMyAudit;
  const adtTo =
    searchData?.myAuditOnly === false || searchData?.myAuditOnly === 0
      ? searchData?.paidDateRangeTo
      : searchData?.toDateRangeForMyAudit;
  // get error msg for NDC
  const getErrorsFromSearchTypeComponent = (errors) => {
    if (errors) {
      // let alreadyPresentErrors = getErrorMsg ? getErrorMsg : [];
      let alreadyPresentErrors = getErrorMsg?.searchScreenErrors
        ? getErrorMsg?.searchScreenErrors
        : [];
      setErrorMsgFromSearchType(errors);
      alreadyPresentErrors = alreadyPresentErrors.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );
      alreadyPresentErrors = alreadyPresentErrors.concat(errors);
      dispatch(
        dispatchErrorMsgForClaimAudit({
          searchScreenErrors: [...new Set(alreadyPresentErrors)],
        })
      );
    }
  };
  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setSearhClaimAuditData({
      fullScreenView: !fullScreenView,
      searchData: searchData,
    });
  };
  // on gride ready functionality
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  // dispatch function for getlabelerData
  React.useEffect(() => {
    if (searchData.selectBy === 'L') {
      dispatch(getAllLabelerData());
    }
  }, [searchData.selectBy]);
  // setting labeler list
  React.useEffect(() => {
    let list = [];
    if (
      labelerList &&
      labelerList.status === STATUS_MSG &&
      labelerList.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(labelerList.data)) {
        list = _.map(labelerList.data, (val, ind) => ({
          ...val,
          labelerCode: val.labelerCode,
          labelerName: val.labelerName,
        }));
      }
    }
    setLabelerListDataList(list);
  }, [labelerList]);

  // get rebate program list
  React.useEffect(() => {
    if (
      _.isEmpty(rebateProgListMD) &&
      _.isEmpty(rebateProgListST) &&
      _.isEmpty(rebateProgListCOMM)
    ) {
      getRebateProgramDataMD('FD').then((res) => {
        setRebateProgListMD(res);
      });
      getRebateProgramDataMD('ST').then((res) => {
        setRebateProgListST(res);
      });
      getRebateProgramDataMD('COMM').then((res) => {
        setRebateProgListCOMM(res);
      });
    }
  }, []);
  // setting Rebate Programe List
  React.useEffect(() => {
    let list = [];
    const rebateProgList = [
      ...rebateProgListMD,
      ...rebateProgListST,
      ...rebateProgListCOMM,
    ];

    if (!_.isEmpty(rebateProgList)) {
      list = _.map(rebateProgList, (val) => ({
        ...val,
        id: val.rebateProgramCd,
        name: `${val.rebateProgramCd} | ${val.shortDescr}`,
      }));
    }

    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  }, [rebateProgListMD, rebateProgListST, rebateProgListCOMM]);
  // get Specific Audit Type Data
  React.useEffect(() => {
    if (searchData.auditType === 'SPC') {
      dispatch(
        getSpecificAuditTypeData({
          domainKey: 'AUDIT_TYPE_CD',
          codeValue: 'C',
        })
      );
    }
  }, [searchData.auditType]);
  // setting Specific Audit Type List
  React.useEffect(() => {
    let list = [];
    if (
      getSpecificAuditTypeListData?.status === STATUS_MSG &&
      getSpecificAuditTypeListData?.message === 'Success'
    ) {
      if (!_.isEmpty(getSpecificAuditTypeListData.invoiceAuditResponse)) {
        list = _.map(
          getSpecificAuditTypeListData.invoiceAuditResponse,
          (val) => ({
            ...val,
            id: val.codeValue,
            name: `${val.codeValue} | ${val.shortDescription}`,
          })
        );
      }
    }
    setSpecificAuditTypeList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  }, [getSpecificAuditTypeListData]);

  // React.useEffect(() => {
  //   if (Object.keys(searchData || {}).length > 0) {
  //     dispatch(dispatchErrorMsgForClaimAudit({ searchScreenErrors: [] }));
  //   }
  // }, [searchData]);

  // on change event on field
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg?.searchScreenErrors || [];
    if (name === 'selectBy' && value !== searchData.selectBy) {
      setSearchData({
        ...searchData,
        [name]: value,
        searchTypeState: {
          valueSelectedRedux: 'NDC',
          ndcSearchTextRedux: '',
          ndcNameSearchTextRedux: '',
          ndcLeftTableDataRedux: [],
          ndcRightTableDataRedux: [],
          labelerTableDataRedux: [],
          ndcLeftSelectedRowsRedux: [],
          ndcRightSelectedRowsRedux: [],
          labelerSelectedRowRedux: '',
          ndcLeftFullScreenRedux: false,
          ndcRightFullScreenRedux: false,
          labelerFullScreenRedux: false,
        },
      });
      setSearchType(
        userDefaults?.defNdcSelectModeCd
          ? userDefaults?.defNdcSelectModeCd === 'NDC'
            ? 'NDC'
            : upperCaseFirstLetter(
                lowerCaseAllWordsExceptFirstLetters(
                  userDefaults?.defNdcSelectModeCd
                )
              )
          : 'NDC'
      );
      setNdcLeftSelectedRows([]);
      setlabelerSelectedRow('');
      setNdcRightSelectedRows([]);
      setlabelerTableData([]);
      setNdcLeftTableData([]);
      setNdcRightTableData([]);
      setNdcSearchVal('');
      setNdcNameSearchVal('');
      dispatch(dispatchErrorMsgForClaimAudit({ searchScreenErrors: [] }));
      setSearhClaimAuditData({
        fullScreenView: fullScreenView,
        searchData: {
          ...searchData,
          [name]: value,
          searchTypeState: {
            valueSelectedRedux: 'NDC',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
            ndcLeftSelectedRowsRedux: [],
            ndcRightSelectedRowsRedux: [],
            labelerSelectedRowRedux: '',
            ndcLeftFullScreenRedux: false,
            ndcRightFullScreenRedux: false,
            labelerFullScreenRedux: false,
          },
        },
      });
      localErr = localErr.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );
      setErrorMsgFromSearchType([]);
    } else if (name === 'unreversed') {
      setSearchData({
        ...searchData,
        [name]: value,
        reversed: (searchData.reversed = 1),
      });
      setSearhClaimAuditData({
        searchData: { ...searchData, [name]: value },
      });
    } else if (name === 'reversed') {
      setSearchData({
        ...searchData,
        [name]: value,
        unreversed: (searchData.unreversed = 1),
      });
      setSearhClaimAuditData({
        searchData: { ...searchData, [name]: value },
      });
    } else if (name === 'myAuditOnly') {
      if (value === 0) {
        setSearchData({
          ...searchData,
          [name]: value,
          fromDateRangeForMyAudit: '',
          toDateRangeForMyAudit: '',
        });
        setSearhClaimAuditData({
          searchData: {
            ...searchData,
            [name]: value,
            fromDateRangeForMyAudit: '',
            toDateRangeForMyAudit: '',
          },
        });
        dispatch(dispatchErrorMsgForClaimAudit({ searchScreenErrors: [] }));
      } else {
        setSearchData({
          ...searchData,
          [name]: value,
          fromDateRangeForMyAudit: moment().format('MM/DD/YYYY'),
          toDateRangeForMyAudit: moment().format('MM/DD/YYYY'),
        });
        setSearhClaimAuditData({
          searchData: {
            ...searchData,
            [name]: value,
          },
        });
        dispatch(dispatchErrorMsgForClaimAudit({ searchScreenErrors: [] }));
      }
    } else {
      setSearchData({ ...searchData, [name]: value });
      setSearhClaimAuditData({
        searchData: { ...searchData, [name]: value },
      });
    }
  };

  //  on Blur event handler on field level
  const handleOnblurEvent = (type, value, name, fieldType) => {
    let localErr = getErrorMsg?.searchScreenErrors || [];
    localErr = localErr.filter((item) => item.field !== 'claimAuditDetailscr');
    const data = value;
    if (name === 'dateField') {
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: type,
              errorType: 'required',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }

        if (checkQuarterValidation(value)) {
          if (type === 'paidDateRangeFrom') {
            localErr = localErr.filter(
              (item) =>
                item.field !== 'paidDateRangeTo' &&
                item.errorType !== 'required' &&
                item.field !== 'claimAuditDetailscr'
            );
            if (searchData?.paidDateRangeTo) {
              if (!searchData?.paidDateRangeTo?.includes('Q')) {
                localErr.push({
                  field: 'paidDateRangeFrom',
                  errorType: 'invalidFormat',
                  message: DATE_QTR_VALIDATION,
                });
              } else if (
                compareQtrs(
                  autoFormateDate(value),
                  autoFormateDate(searchData.paidDateRangeTo)
                )
              ) {
                localErr.push({
                  field: 'paidDateRangeTo',
                  errorType: 'invalidFormat',
                  message: TO_DATE_CANT_BE_LESS_THAN_FROM,
                });
              } else {
                localErr = localErr?.filter(
                  (item) =>
                    item.field !== 'paidDateRangeTo' &&
                    item.field !== 'paidDateRangeFrom'
                );
              }
              const formattedDate = autoFormateDate(value?.toUpperCase());
              setSearchData({
                ...searchData,
                paidDateRangeFrom: formattedDate,
              });
              setSearhClaimAuditData({
                searchData: {
                  ...searchData,
                  paidDateRangeFrom: formattedDate,
                },
              });
              localErr = localErr.filter(
                (item) => item.field !== 'paidDateRangeFrom'
              );
            } else {
              const formattedDate = autoFormateDate(value?.toUpperCase());
              setSearchData({
                ...searchData,
                paidDateRangeFrom: formattedDate,
                paidDateRangeTo: formattedDate,
              });
              setSearhClaimAuditData({
                searchData: {
                  ...searchData,
                  paidDateRangeFrom: formattedDate,
                  paidDateRangeTo: formattedDate,
                },
              });
              localErr = localErr.filter(
                (item) => item.field !== 'paidDateRangeFrom'
              );
            }
          }
          if (type === 'paidDateRangeTo') {
            if (checkQuarterValidation(searchData?.paidDateRangeTo)) {
              const indexOF = !_.isEmpty(localErr)
                ? _.findIndex(localErr, {
                    field: 'paidDateRangeTo',
                    errorType: 'invalidFormat',
                  })
                : null;

              if (!_.isNull(indexOF) && indexOF >= 0) {
                localErr.splice(indexOF, 1);
              }
            }
            if (searchData?.paidDateRangeFrom) {
              if (!searchData?.paidDateRangeFrom?.includes('Q')) {
                localErr.push({
                  field: 'paidDateRangeTo',
                  errorType: 'invalidFormat',
                  message: DATE_QTR_VALIDATION,
                });
              } else if (
                compareQtrs(
                  autoFormateDate(searchData.paidDateRangeFrom),
                  autoFormateDate(value)
                )
              ) {
                localErr.push({
                  field: 'paidDateRangeTo',
                  errorType: 'invalidFormat',
                  message: TO_DATE_CANT_BE_LESS_THAN_FROM,
                });
              } else {
                localErr = localErr?.filter(
                  (item) =>
                    item.field !== 'paidDateRangeTo' &&
                    item.field !== 'paidDateRangeFrom'
                );
              }
            }
            const formattedDate = autoFormateDate(value?.toUpperCase());
            setSearchData({
              ...searchData,
              paidDateRangeTo: formattedDate,
            });
            setSearhClaimAuditData({
              searchData: {
                ...searchData,
                paidDateRangeTo: formattedDate,
              },
            });
          }
          const indexOf = !_.isEmpty(localErr)
            ? _.findIndex(localErr, {
                field: type,
                errorType: 'required',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            localErr.splice(indexOf, 1);
          }
        } else if (isCheckDateFormat(autoFormateDate(value))) {
          const receivedDate = autoFormateDate(value);
          if (type === 'paidDateRangeFrom') {
            localErr = localErr.filter(
              (item) =>
                item.field !== 'paidDateRangeTo' &&
                item.errorType !== 'required' &&
                item.field !== 'claimAuditDetailscr'
            );
            if (searchData?.paidDateRangeTo) {
              if (!searchData?.paidDateRangeTo?.includes('/')) {
                localErr.push({
                  field: 'paidDateRangeFrom',
                  errorType: 'invalidFormat',
                  message: DATE_QTR_VALIDATION,
                });
              } else if (
                compareTwoDatesGreaterThanOrEqual(
                  new Date(autoFormateDate(searchData.paidDateRangeTo)),
                  new Date(receivedDate)
                )
              ) {
                localErr.push({
                  field: 'paidDateRangeTo',
                  errorType: 'invalidFormat',
                  message: TO_DATE_CANT_BE_LESS_THAN_FROM,
                });
              } else {
                localErr = localErr?.filter(
                  (item) =>
                    item.field !== 'paidDateRangeTo' &&
                    item.field !== 'paidDateRangeFrom'
                );
              }
              setSearchData({
                ...searchData,
                paidDateRangeFrom: receivedDate,
              });
              setSearhClaimAuditData({
                searchData: {
                  ...searchData,
                  paidDateRangeFrom: receivedDate,
                },
              });
              localErr = localErr.filter(
                (item) => item.field !== 'paidDateRangeFrom'
              );
            } else {
              setSearchData({
                ...searchData,
                paidDateRangeFrom: receivedDate,
                paidDateRangeTo: receivedDate,
              });
              setSearhClaimAuditData({
                searchData: {
                  ...searchData,
                  paidDateRangeFrom: receivedDate,
                  paidDateRangeTo: receivedDate,
                },
              });
              localErr = localErr.filter(
                (item) => item.field !== 'paidDateRangeFrom'
              );
            }
          }

          if (type === 'paidDateRangeTo') {
            if (searchData?.paidDateRangeFrom) {
              if (!searchData?.paidDateRangeFrom?.includes('/')) {
                localErr.push({
                  field: 'paidDateRangeTo',
                  errorType: 'invalidFormat',
                  message: DATE_QTR_VALIDATION,
                });
              } else if (
                compareTwoDatesGreaterThanOrEqual(
                  new Date(value),
                  new Date(searchData.paidDateRangeFrom)
                )
              ) {
                localErr.push({
                  field: 'paidDateRangeTo',
                  errorType: 'invalidFormat',
                  message: TO_DATE_CANT_BE_LESS_THAN_FROM,
                });
              } else {
                localErr = localErr?.filter(
                  (item) =>
                    item.field !== 'paidDateRangeTo' &&
                    item.field !== 'paidDateRangeFrom'
                );
              }
            }
            setSearchData({
              ...searchData,
              paidDateRangeTo: receivedDate,
            });
            setSearhClaimAuditData({
              searchData: {
                ...searchData,
                paidDateRangeTo: receivedDate,
              },
            });
            // localErr = localErr.filter(
            //   (item) => item.field !== 'toDateRangeForMyAudit'
            // );
          }
          const indexOf = !_.isEmpty(localErr)
            ? _.findIndex(localErr, {
                field: type,
                errorType: 'required',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            localErr.splice(indexOf, 1);
          }
          // localErr = localErr.filter((item) => item.field !== type);
        } else {
          localErr = localErr.filter((item) => item.field !== type);
          localErr.push({
            field: type,
            errorType: 'invalidFormat',
            message: DATE_QTR_VALIDATION,
          });
        }
        if (searchData?.myAuditOnly === 1) {
          if (checkQuarterValidation(value)) {
            if (type === 'fromDateRangeForMyAudit') {
              localErr = localErr.filter(
                (item) =>
                  item.field !== 'toDateRangeForMyAudit' &&
                  item.errorType !== 'required' &&
                  item.field !== 'claimAuditDetailscr'
              );
              if (searchData?.toDateRangeForMyAudit) {
                if (!searchData?.toDateRangeForMyAudit?.includes('Q')) {
                  localErr.push({
                    field: 'fromDateRangeForMyAudit',
                    errorType: 'invalidFormat',
                    message: DATE_QTR_VALIDATION,
                  });
                } else if (
                  compareQtrs(
                    autoFormateDate(value),
                    autoFormateDate(searchData.toDateRangeForMyAudit)
                  )
                ) {
                  localErr.push({
                    field: 'toDateRangeForMyAudit',
                    errorType: 'invalidFormat',
                    message: TO_DATE_CANT_BE_LESS_THAN_FROM,
                  });
                } else {
                  localErr = localErr?.filter(
                    (item) =>
                      item.field !== 'toDateRangeForMyAudit' &&
                      item.field !== 'fromDateRangeForMyAudit'
                  );
                }
                const formattedDate = autoFormateDate(value?.toUpperCase());
                setSearchData({
                  ...searchData,
                  fromDateRangeForMyAudit: formattedDate,
                });
                setSearhClaimAuditData({
                  searchData: {
                    ...searchData,
                    fromDateRangeForMyAudit: formattedDate,
                  },
                });
                localErr = localErr.filter(
                  (item) => item.field !== 'fromDateRangeForMyAudit'
                );
              } else {
                const formattedDate = autoFormateDate(value?.toUpperCase());
                setSearchData({
                  ...searchData,
                  fromDateRangeForMyAudit: value?.toUpperCase(),
                  toDateRangeForMyAudit: value?.toUpperCase(),
                });
                setSearhClaimAuditData({
                  searchData: {
                    ...searchData,
                    fromDateRangeForMyAudit: formattedDate,
                    toDateRangeForMyAudit: formattedDate,
                  },
                });
                localErr = localErr.filter(
                  (item) => item.field !== 'fromDateRangeForMyAudit'
                );
              }
            }
            if (type === 'toDateRangeForMyAudit') {
              if (checkQuarterValidation(searchData?.toDateRangeForMyAudit)) {
                const indexOF = !_.isEmpty(localErr)
                  ? _.findIndex(localErr, {
                      field: 'toDateRangeForMyAudit',
                      errorType: 'invalidFormat',
                    })
                  : null;

                if (!_.isNull(indexOF) && indexOF >= 0) {
                  localErr.splice(indexOF, 1);
                }
              }
              if (searchData?.fromDateRangeForMyAudit) {
                if (!searchData?.fromDateRangeForMyAudit?.includes('Q')) {
                  localErr.push({
                    field: 'toDateRangeForMyAudit',
                    errorType: 'invalidFormat',
                    message: DATE_QTR_VALIDATION,
                  });
                } else if (
                  compareQtrs(
                    autoFormateDate(searchData.fromDateRangeForMyAudit),
                    autoFormateDate(value)
                  )
                ) {
                  localErr.push({
                    field: 'toDateRangeForMyAudit',
                    errorType: 'invalidFormat',
                    message: TO_DATE_CANT_BE_LESS_THAN_FROM,
                  });
                } else {
                  localErr = localErr?.filter(
                    (item) =>
                      item.field !== 'toDateRangeForMyAudit' &&
                      item.field !== 'fromDateRangeForMyAudit'
                  );
                }
              }
              const formattedDate = autoFormateDate(value?.toUpperCase());
              setSearchData({
                ...searchData,
                toDateRangeForMyAudit: formattedDate,
              });
              setSearhClaimAuditData({
                searchData: {
                  ...searchData,
                  toDateRangeForMyAudit: formattedDate,
                },
              });
            }
            const indexOf = !_.isEmpty(localErr)
              ? _.findIndex(localErr, {
                  field: type,
                  errorType: 'required',
                })
              : null;

            if (!_.isNull(indexOf) && indexOf >= 0) {
              localErr.splice(indexOf, 1);
            }
          } else if (isCheckDateFormat(autoFormateDate(value))) {
            const receivedDate = autoFormateDate(value);
            if (type === 'fromDateRangeForMyAudit') {
              localErr = localErr.filter(
                (item) =>
                  item.field !== 'toDateRangeForMyAudit' &&
                  item.errorType !== 'required' &&
                  item.field !== 'claimAuditDetailscr'
              );
              if (searchData?.toDateRangeForMyAudit) {
                if (!searchData?.toDateRangeForMyAudit?.includes('/')) {
                  localErr.push({
                    field: 'fromDateRangeForMyAudit',
                    errorType: 'invalidFormat',
                    message: DATE_QTR_VALIDATION,
                  });
                } else if (
                  compareTwoDatesGreaterThanOrEqual(
                    new Date(autoFormateDate(searchData.toDateRangeForMyAudit)),
                    new Date(receivedDate)
                  )
                ) {
                  localErr.push({
                    field: 'toDateRangeForMyAudit',
                    errorType: 'invalidFormat',
                    message: TO_DATE_CANT_BE_LESS_THAN_FROM,
                  });
                } else {
                  localErr = localErr?.filter(
                    (item) =>
                      item.field !== 'toDateRangeForMyAudit' &&
                      item.field !== 'fromDateRangeForMyAudit'
                  );
                }
                setSearchData({
                  ...searchData,
                  fromDateRangeForMyAudit: receivedDate,
                });
                setSearhClaimAuditData({
                  searchData: {
                    ...searchData,
                    fromDateRangeForMyAudit: receivedDate,
                  },
                });
                localErr = localErr.filter(
                  (item) => item.field !== 'fromDateRangeForMyAudit'
                );
              } else {
                setSearchData({
                  ...searchData,
                  fromDateRangeForMyAudit: receivedDate,
                  toDateRangeForMyAudit: receivedDate,
                });
                setSearhClaimAuditData({
                  searchData: {
                    ...searchData,
                    fromDateRangeForMyAudit: receivedDate,
                    toDateRangeForMyAudit: receivedDate,
                  },
                });
                localErr = localErr.filter(
                  (item) => item.field !== 'fromDateRangeForMyAudit'
                );
              }
            }
            if (type === 'toDateRangeForMyAudit') {
              if (searchData?.fromDateRangeForMyAudit) {
                if (!searchData?.fromDateRangeForMyAudit?.includes('/')) {
                  localErr.push({
                    field: 'toDateRangeForMyAudit',
                    errorType: 'invalidFormat',
                    message: DATE_QTR_VALIDATION,
                  });
                } else if (
                  compareTwoDatesGreaterThanOrEqual(
                    new Date(value),
                    new Date(searchData.fromDateRangeForMyAudit)
                  )
                ) {
                  localErr.push({
                    field: 'toDateRangeForMyAudit',
                    errorType: 'invalidFormat',
                    message: TO_DATE_CANT_BE_LESS_THAN_FROM,
                  });
                } else {
                  localErr = localErr?.filter(
                    (item) =>
                      item.field !== 'toDateRangeForMyAudit' &&
                      item.field !== 'fromDateRangeForMyAudit'
                  );
                }
              }
              setSearchData({
                ...searchData,
                toDateRangeForMyAudit: receivedDate,
              });
              setSearhClaimAuditData({
                searchData: {
                  ...searchData,
                  toDateRangeForMyAudit: receivedDate,
                },
              });
              // localErr = localErr.filter(
              //   (item) => item.field !== 'toDateRangeForMyAudit'
              // );
            }
            const indexOf = !_.isEmpty(localErr)
              ? _.findIndex(localErr, {
                  field: type,
                  errorType: 'required',
                })
              : null;

            if (!_.isNull(indexOf) && indexOf >= 0) {
              localErr.splice(indexOf, 1);
            }
            // localErr = localErr.filter((item) => item.field !== type);
          } else {
            localErr = localErr.filter((item) => item.field !== type);
            localErr.push({
              field: type,
              errorType: 'invalidFormat',
              message: DATE_QTR_VALIDATION,
            });
          }
        }
      } else {
        localErr = localErr.filter((item) => item.field !== type);
        localErr.push({
          field: type,
          errorType: 'required',
          message:
            fieldType === 'fromField'
              ? FROM_DATE_QTR_REQUIRED
              : TO_DATE_QTR_REQUIRED,
        });
      }
    }
    if (!searchData?.myAuditOnly) {
      if (type === 'rebateProgramCd') {
        if (!value || value === '-1') {
          localErr = localErr.filter(
            (item) => item.field !== 'rebateProgramCd'
          );
          localErr.push({
            field: 'rebateProgramCd',
            errorType: 'rebateRequired',
            message: REBATE_PROGRAM_REQUIRED,
          });
        } else {
          localErr = localErr.filter(
            (item) => item.field !== 'rebateProgramCd'
          );
        }
      }
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgForClaimAudit({ searchScreenErrors: unique }));
  };

  // on Click functionality on View Claim Detail button
const onClickOnViewClaimDetail = async (data, bypass = false) => {
  let localErr = [];
  const labelerCodeForPay = data?.labelerCode;

  let drugSeqArr = [];

  if (searchData.selectBy === 'NDC') {
    if (data?.length > 1000 && !bypass) {
      setSelectedData(data); 
      setOpenModal(true);      

      return; 
    }

    const limit = Math.min(data?.length, 1000);
    drugSeqArr = data.slice(0, limit).map(d => d.drugSeqNum);
  }

  if (!searchData?.myAuditOnly) {
    if (
      !searchData?.paidDateRangeFrom ||
      _.isEmpty(searchData?.paidDateRangeFrom)
    ) {
      handleScrollToEvent();
      localErr.push({
        field: 'paidDateRangeFrom',
        errorType: 'required',
        message: FROM_DATE_QTR_REQUIRED,
      });
    }

    if (
      !searchData?.rebateProgramCd ||
      searchData?.rebateProgramCd === '-1'
    ) {
      handleScrollToEvent();
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
  }

  if (localErr.length) {
    dispatch(dispatchErrorMsgForClaimAudit({
      searchScreenErrors: [...new Set(localErr)]
    }));
    return;
  }

  let popupCountPayObj = {
    showMyAuditOnly: searchData?.myAuditOnly ? 1 : 0,
    fromDtPaid: adtFrom,
    toDtPaid: adtTo,
    rebateProgramCd: searchData?.rebateProgramCd,
    clearedInd: searchData?.clearAudit,
    reversalInd: searchData?.reversed,
    unReversalInd: searchData?.unreversed,
    selectByAll: searchData?.selectBy === 'A' ? 1 : 0,
    auditType:
      searchData?.auditType === 'ALL'
        ? 'A'
        : searchData?.auditType === 'GRP'
        ? 'G'
        : searchData?.auditType === 'SPC'
        ? 'I'
        : searchData?.auditType,
    userId: logInUser,
  };

  if (searchData.auditType === 'SPC') {
    popupCountPayObj.auditTypeSpc = searchData?.speAuditType;
  }

  let payLoadObj = {
    programcd: searchData?.rebateProgramCd,
    adtFrom: adtFrom,
    adtTo: adtTo,
    claimaudittype: searchData?.auditType,
    asCode: searchData?.selectBy === 'NDC' ? 'N' : searchData?.selectBy,
    claimReversalInd: searchData?.reversed,
    claimUnreversalInd: searchData?.unreversed,
    auditClearedInd: searchData?.clearAudit,
    lastUpdateUserId: logInUser,
  };

  let payLoadObjShowMyAudit = {
    lastUpdateUserId: logInUser,
    adtFrom: adtFrom,
    adtTo: adtTo,
    claimaudittype: searchData?.auditType,
    asCode: searchData?.selectBy === 'NDC' ? 'N' : searchData?.selectBy,
    claimReversalInd: searchData?.reversed,
    claimUnreversalInd: searchData?.unreversed,
    auditClearedInd: searchData?.clearAudit,
  };

  if (searchData.auditType === 'SPC') {
    payLoadObj.claimspctype = searchData?.speAuditType;
  }

  setPayloadForDetailAPI({
    selectBy: searchData?.selectBy,
    labelerCodeForPay,
    drugSeqArr,
    payLoadObj,              
    payLoadObjShowMyAudit,
    searchData,
  });

  const countAmount = await dispatch(
    searchData?.selectBy === 'L'
      ? getClaimAuditPopupCountDataApi({
          ...popupCountPayObj,
          mfgId: labelerCodeForPay,
        })
      : searchData?.selectBy === 'NDC'
      ? getClaimAuditPopupCountDataApi({
          ...popupCountPayObj,
          drugSeqNum: drugSeqArr,
        })
      : getClaimAuditPopupCountDataApi(popupCountPayObj)
  );

  const countResponse =
    countAmount?.payload?.claimAuditResponse;

  if (countResponse > 0) {
    setCount(countResponse);
    setOpenConfirm(true);
  } else {
    handleScrollToEvent();
    dispatch(dispatchErrorMsgForClaimAudit({
      searchScreenErrors: [
        {
          field: 'claimAuditDetailscr',
          errorType: 'noData',
          message: MNFC_NDC_ERROR_MSG,
        },
      ],
    }));
  }
};

  const popupOnConfirmYes = async () => {
    if (!payloadForDetailAPI) return; 

    const {
      selectBy,
      labelerCodeForPay,
      drugSeqArr,
      payLoadObj,
      payLoadObjShowMyAudit,
      searchData,
    } = payloadForDetailAPI;

    const detailResult = await dispatch(
      selectBy === 'L'
        ? getClaimAuditDetailData({
            ...payLoadObj,
            labelerCode: labelerCodeForPay,
          })
        : selectBy === 'NDC'
        ? getClaimAuditDetailData({
            ...payLoadObj,
            drugseqnum: drugSeqArr,
          })
        : searchData.auditType === 'GRP'
        ? getClaimAuditDetailData({
            ...payLoadObj,
            claimgrptypeUA: searchData?.amountAudit === 1 ? 'UA' : null,
            claimgrptypeUCA:
              searchData?.unitConversionAudit === 1 ? 'UCA' : null,
            claimgrptypeOA: searchData?.otherAudit === 1 ? 'OA' : null,
          })
        : searchData.auditType === 'SPC'
        ? getClaimAuditDetailData({
            ...payLoadObj,
            claimspctype: searchData?.speAuditType,
          })
        : searchData.myAuditOnly === 1
        ? getClaimAuditDetailData(payLoadObjShowMyAudit)
        : getClaimAuditDetailData(payLoadObj)
    );

    if (detailResult?.claimAuditResponse?.length > 0) {
      dispatch(dispatchClaimAuditDetail(detailResult));
      redirectURLLink(
        '/ClaimAuditViewDetails',
        'Claim Audit View Details',
        history
      );
    } else {
      dispatch(
        dispatchErrorMsgForClaimAudit({
          searchScreenErrors: [
            {
              field: 'claimAuditDetailscr',
              errorType: 'noDataforPerSelection',
              message: detailResult?.error
                ? API_TIMEOUT_ERROR
                : FAILED_MESSAGE_GENERIC,
            },
          ],
        })
      );
    }

    setOpenConfirm(false);
  };

  const handleExportAllToExcel = React.useCallback(async () => {
    if (!payloadForDetailAPI) {
      return;
    }

    const {
      selectBy,
      labelerCodeForPay,
      drugSeqArr,
      payLoadObj,
      payLoadObjShowMyAudit,
      searchData,
    } = payloadForDetailAPI;

    const finalPayload =
      selectBy === 'L'
        ? { ...payLoadObj, labelerCode: labelerCodeForPay }
        : selectBy === 'NDC'
        ? { ...payLoadObj, drugseqnum: drugSeqArr }
        : searchData.auditType === 'GRP'
        ? {
            ...payLoadObj,
            claimgrptypeUA: searchData?.amountAudit === 1 ? 'UA' : null,
            claimgrptypeUCA:
              searchData?.unitConversionAudit === 1 ? 'UCA' : null,
            claimgrptypeOA: searchData?.otherAudit === 1 ? 'OA' : null,
          }
        : searchData.auditType === 'SPC'
        ? { ...payLoadObj, claimspctype: searchData?.speAuditType }
        : searchData.myAuditOnly === 1
        ? payLoadObjShowMyAudit
        : payLoadObj;

    try {
      const result = await dispatch(getExportAllDetail(finalPayload));
    } catch (error) {}
  }, [payloadForDetailAPI, dispatch]);

  React.useEffect(() => {
    if (payloadForDetailAPI) {
      dispatch(setExportHandler(handleExportAllToExcel));
    }
  }, [payloadForDetailAPI, dispatch, handleExportAllToExcel]);

  const popupOnConfirm = () => {
    setOpenConfirm(!openConfirm);
  };

  React.useEffect(() => {
    if (
      getErrorMsg?.searchScreenErrors &&
      getErrorMsg?.searchScreenErrors.length > 0
    ) {
      tabHighLigther(navigate, true);
    } else {
      tabHighLigther(navigate, false);
    }
  }, [JSON.stringify(getErrorMsg)]);

  // hanlde onclick on of yes from confirmation modal
  const handleYes = () => {
    onClickOnViewClaimDetail(selectedData, true);
  };

  return (
    <div
      className=" tabs-container tBillPanel custom-check"
      data-testid="ClaimAuditSelect"
    >
      <CommonModal
        open={openModal}
        viewAction
        viewHeader
        className="dialog-420"
        data-testid="common-modal-display"
        onOk={() => {
          setOpenModal(false);
          handleYes();
        }}
        okTitle="Yes"
        onClose={() => {
          setOpenModal(false);
          setSelectedData([]);
        }}
        closeTitle="No"
        modalTitle="Confirmation Dialog"
        childrenComponent={<div className="p-3">{NDC_LIMIT_TO_1000}</div>}
      />
      <CommonModal
        open={openConfirm}
        className="dialogPanel custom-check dialog-600"
        data-testid="common-modal"
        viewAction
        viewHeader
        modalTitle="Select Claim Audits"
        okTitle="Yes"
        closeTitle="No"
        removeClassName
        childrenComponent={
          <>
            <div>
              This selection criteria will result in the display of {count}
              &nbsp; audits. Do you wish to proceed ?
            </div>
          </>
        }
        onOk={() => {
          popupOnConfirmYes();
        }}
        onClose={() => {
          popupOnConfirm();
        }}
      />

      <Spinner load={spinnerLoader} />
      <CustomSeparator parent1="Research" parent2="Claim Audit Select" />
      {getErrorMsg?.searchScreenErrors?.length > 0 ? (
        <DisplayErrorMessages
          errorMessages={[
            ...new Set(
              getErrorMsg?.searchScreenErrors?.length > 0
                ? _.map(getErrorMsg.searchScreenErrors, (l) => l.message)
                : []
            ),
          ]}
        />
      ) : null}
      {!fullScreenView && (
        <div className="row align-items-center">
          {!searchData?.myAuditOnly && (
            <div className="col-4 col-sm-6 col-md-4 col-lg-4 mb-3">
              <fieldset className="custom-fieldset">
                <legend>
                  Paid Date/Qtr Range
                  {!searchData?.myAuditOnly && (
                    <span className="mandatory"> *</span>
                  )}
                </legend>
                <div className="row pt-1">
                  <div className="col-5 mui-custom-form">
                    <TextField
                      data-testid="paid-date-range-from"
                      id="paid-date-range-from-id"
                      label={textFieldLabelFrom}
                      fullWidth
                      inputProps={{ maxLength: 10 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={searchData?.paidDateRangeFrom}
                      className={
                        getErrorMsg?.searchScreenErrors?.length > 0
                          ? _.map(getErrorMsg?.searchScreenErrors, (l) =>
                              l.field === 'paidDateRangeFrom'
                                ? 'mandate-fields'
                                : null
                            )
                          : null
                      }
                      onBlur={(e) =>
                        handleOnblurEvent(
                          'paidDateRangeFrom',
                          e.target.value,
                          'dateField',
                          'fromField'
                        )
                      }
                      onChange={(e) => {
                        handleOnChangeEvent(
                          e.target.value,
                          'paidDateRangeFrom'
                        );
                      }}
                      error={
                        getErrorMsg?.searchScreenErrors?.length > 0 &&
                        getErrorMsg?.searchScreenErrors?.filter((x) => {
                          return x.field === 'paidDateRangeFrom';
                        }).length > 0
                          ? [
                              ...new Set(
                                getErrorMsg?.searchScreenErrors
                                  ?.filter((x) => {
                                    return x.field === 'paidDateRangeFrom';
                                  })
                                  .map((item) => {
                                    return item.message;
                                  })
                              ),
                            ]
                          : false
                      }
                      helperText={
                        getErrorMsg?.searchScreenErrors?.length > 0
                          ? [
                              ...new Set(
                                getErrorMsg?.searchScreenErrors
                                  ?.filter((x) => {
                                    return x.field === 'paidDateRangeFrom';
                                  })
                                  .map((item) => {
                                    return item.message;
                                  })
                              ),
                            ]
                          : null
                      }
                    />
                  </div>
                  <div className="col-5 mui-custom-form">
                    <TextField
                      data-testid="paid-Date-Range-To"
                      id="paid-Date-Range-To-id"
                      label={textFieldLabelTo}
                      fullWidth
                      inputProps={{ maxLength: 10 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className={
                        getErrorMsg?.searchScreenErrors?.length > 0
                          ? _.map(getErrorMsg?.searchScreenErrors, (l) =>
                              l.field === 'paidDateRangeTo'
                                ? 'mandate-fields'
                                : null
                            )
                          : null
                      }
                      value={searchData?.paidDateRangeTo}
                      onChange={(e) => {
                        handleOnChangeEvent(e.target.value, 'paidDateRangeTo');
                      }}
                      onBlur={(e) =>
                        handleOnblurEvent(
                          'paidDateRangeTo',
                          e.target.value,
                          'dateField',
                          'toField'
                        )
                      }
                      error={
                        getErrorMsg?.searchScreenErrors?.length > 0 &&
                        getErrorMsg?.searchScreenErrors?.filter((x) => {
                          return x.field === 'paidDateRangeTo';
                        }).length > 0
                          ? [
                              ...new Set(
                                getErrorMsg?.searchScreenErrors
                                  ?.filter((x) => {
                                    return x.field === 'paidDateRangeTo';
                                  })
                                  .map((item) => {
                                    return item.message;
                                  })
                              ),
                            ]
                          : false
                      }
                      helperText={
                        getErrorMsg?.searchScreenErrors?.length > 0
                          ? [
                              ...new Set(
                                getErrorMsg?.searchScreenErrors
                                  ?.filter((x) => {
                                    return x.field === 'paidDateRangeTo';
                                  })
                                  .map((item) => {
                                    return item.message;
                                  })
                              ),
                            ]
                          : null
                      }
                    />
                  </div>
                </div>
              </fieldset>
            </div>
          )}
          {!searchData?.myAuditOnly && (
            <div className="col-4 col-sm-6 col-md-4 col-lg-4 mb-1 ">
              <fieldset
                data-testid="radio-box-component"
                className="custom-fieldset pb-3 pt-3"
              >
                <div className="mui-custom-form with-select">
                  <TextField
                    data-testid="rebate_program-claim-audit-dropdown"
                    id="claim-audit-dropdown"
                    label={rebateProgramLable}
                    className={
                      getErrorMsg?.searchScreenErrors?.length > 0
                        ? _.map(getErrorMsg?.searchScreenErrors, (l) =>
                            l.field === 'rebateProgramCd'
                              ? 'mandate-fields'
                              : null
                          )
                        : null
                    }
                    fullWidth
                    select
                    required
                    placeholder=""
                    inputProps={{ maxLength: 11, id: 'claim-audit-dropdown' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onBlur={(e) =>
                      handleOnblurEvent(
                        'rebateProgramCd',
                        e.target.value,
                        'rebate'
                      )
                    }
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                    }
                    value={
                      searchData && searchData.rebateProgramCd
                        ? searchData.rebateProgramCd
                        : ''
                    }
                    error={
                      getErrorMsg?.searchScreenErrors?.length > 0 &&
                      getErrorMsg?.searchScreenErrors?.filter((x) => {
                        return x.field === 'rebateProgramCd';
                      }).length > 0
                        ? [
                            ...new Set(
                              getErrorMsg?.searchScreenErrors
                                ?.filter((x) => {
                                  return x.field === 'rebateProgramCd';
                                })
                                .map((item) => {
                                  return item.message;
                                })
                            ),
                          ]
                        : false
                    }
                    helperText={
                      getErrorMsg?.searchScreenErrors?.length > 0
                        ? [
                            ...new Set(
                              getErrorMsg?.searchScreenErrors
                                ?.filter((x) => {
                                  return x.field === 'rebateProgramCd';
                                })
                                .map((item) => {
                                  return item.message;
                                })
                            ),
                          ]
                        : null
                    }
                  >
                    <MenuItem
                      key=""
                      value="-1"
                      className="frr-dropdown-blank-item"
                    />
                    {rebateProgramList &&
                    rebateProgramList.length &&
                    rebateProgramList.length > 0
                      ? rebateProgramList.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
              </fieldset>
            </div>
          )}
          <div className="col-4 col-sm-6 col-md-4 col-lg-4">
            <FormControlLabel
              className="ml-0 "
              data-testid="checked_ia1"
              control={<Checkbox color="primary" className="mr-2" />}
              label={showMyAuditsOnlyLable}
              value={searchData?.myAuditOnly}
              checked={searchData?.myAuditOnly}
              onChange={(e) => {
                handleOnChangeEvent(e.target.checked ? 1 : 0, 'myAuditOnly');
              }}
            />
          </div>
        </div>
      )}
      {!fullScreenView && (
        <div className="row">
          <div className="col-4 col-md-4 col-sm-6 col-lg-4 mb-3">
            <fieldset className="custom-fieldset">
              <legend>Date/Qtr Range For My Audits</legend>
              <div className="row">
                <div className="col-5 mui-custom-form">
                  <TextField
                    data-testid="date-range-for-my-audit-from"
                    id="date-range-for-my-audit-from-id"
                    label={textFieldLabelFrom}
                    fullWidth
                    disabled={searchData?.myAuditOnly !== 1}
                    placeholder=""
                    inputProps={{ maxLength: 10 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={
                      searchData?.myAuditOnly === 0
                        ? ''
                        : searchData?.fromDateRangeForMyAudit
                    }
                    className={
                      searchData?.myAuditOnly === 1 &&
                      getErrorMsg?.searchScreenErrors?.length > 0
                        ? _.map(getErrorMsg?.searchScreenErrors, (l) =>
                            l.field === 'fromDateRangeForMyAudit'
                              ? 'mandate-fields'
                              : null
                          )
                        : null
                    }
                    onChange={(e) => {
                      handleOnChangeEvent(
                        e.target.value,
                        'fromDateRangeForMyAudit'
                      );
                    }}
                    onBlur={(e) =>
                      handleOnblurEvent(
                        'fromDateRangeForMyAudit',
                        e.target.value,
                        'dateField',
                        'fromField'
                      )
                    }
                    error={
                      searchData?.myAuditOnly === 1 &&
                      getErrorMsg?.searchScreenErrors?.length > 0 &&
                      getErrorMsg?.searchScreenErrors?.filter((x) => {
                        return x.field === 'fromDateRangeForMyAudit';
                      }).length > 0
                        ? [
                            ...new Set(
                              getErrorMsg?.searchScreenErrors
                                ?.filter((x) => {
                                  return x.field === 'fromDateRangeForMyAudit';
                                })
                                .map((item) => {
                                  return item.message;
                                })
                            ),
                          ]
                        : false
                    }
                    helperText={
                      searchData?.myAuditOnly === 1 &&
                      getErrorMsg?.searchScreenErrors?.length > 0
                        ? [
                            ...new Set(
                              getErrorMsg?.searchScreenErrors
                                ?.filter((x) => {
                                  return x.field === 'fromDateRangeForMyAudit';
                                })
                                .map((item) => {
                                  return item.message;
                                })
                            ),
                          ]
                        : null
                    }
                  />
                </div>
                <div className="col-5 mui-custom-form">
                  <TextField
                    data-testid="date-range-for-my-audit-to"
                    id="date-range-for-my-audit-to-id"
                    label={textFieldLabelTo}
                    fullWidth
                    placeholder=""
                    disabled={searchData?.myAuditOnly !== 1}
                    inputProps={{ maxLength: 10 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    className={
                      searchData?.myAuditOnly === 1 &&
                      getErrorMsg?.searchScreenErrors?.length > 0
                        ? _.map(getErrorMsg?.searchScreenErrors, (l) =>
                            l.field === 'toDateRangeForMyAudit'
                              ? 'mandate-fields'
                              : null
                          )
                        : null
                    }
                    value={
                      searchData?.myAuditOnly === 0
                        ? ''
                        : searchData?.toDateRangeForMyAudit
                    }
                    onChange={(e) => {
                      handleOnChangeEvent(
                        e.target.value,
                        'toDateRangeForMyAudit'
                      );
                    }}
                    onBlur={(e) =>
                      handleOnblurEvent(
                        'toDateRangeForMyAudit',
                        e.target.value,
                        'dateField',
                        'toField'
                      )
                    }
                    error={
                      searchData?.myAuditOnly === 1 &&
                      getErrorMsg?.searchScreenErrors?.length > 0 &&
                      getErrorMsg?.searchScreenErrors?.filter((x) => {
                        return x.field === 'toDateRangeForMyAudit';
                      }).length > 0
                        ? [
                            ...new Set(
                              getErrorMsg?.searchScreenErrors
                                ?.filter((x) => {
                                  return x.field === 'toDateRangeForMyAudit';
                                })
                                .map((item) => {
                                  return item.message;
                                })
                            ),
                          ]
                        : false
                    }
                    helperText={
                      searchData?.myAuditOnly === 1 &&
                      getErrorMsg?.searchScreenErrors?.length > 0
                        ? [
                            ...new Set(
                              getErrorMsg?.searchScreenErrors
                                ?.filter((x) => {
                                  return x.field === 'toDateRangeForMyAudit';
                                })
                                .map((item) => {
                                  return item.message;
                                })
                            ),
                          ]
                        : null
                    }
                  />
                </div>
              </div>
            </fieldset>
          </div>
          <div className="col-4 col-sm-6 col-md-4 mb-3 col-lg-4 frr-checkbox-100per-width">
            <fieldset className="custom-fieldset w-100  d-flex align-items-center flex-md-column flex-xl-row">
              <legend>
                Reversal Status <span className="mandatory"> *</span>
              </legend>
              <FormControlLabel
                className="ml-0 "
                data-testid="checked_ia2"
                control={<Checkbox color="primary" className="mr-2" />}
                label={unreversedLable}
                value={searchData?.unreversed}
                checked={searchData?.unreversed}
                onChange={(e) => {
                  handleOnChangeEvent(e.target.checked ? 1 : 0, 'unreversed');
                }}
              />
              <FormControlLabel
                className="ml-0"
                data-testid="checked_ia3"
                control={<Checkbox color="primary" className="mr-2" />}
                label={reversedLable}
                value={searchData?.reversed}
                checked={searchData?.reversed}
                onChange={(e) =>
                  handleOnChangeEvent(e.target.checked ? 1 : 0, 'reversed')
                }
              />
            </fieldset>
          </div>
          <div className="col-4 col-sm-12 mb-3 col-md-4 d-flex align-items-center col-lg-4">
            <FormControlLabel
              className="ml-0"
              data-testid="include-cleared-audits-checkBox"
              control={<Checkbox color="primary" className="mr-2" />}
              label={includeClearedAuditsLabel}
              value={searchData?.clearAudit}
              checked={searchData?.clearAudit}
              onChange={(e) =>
                handleOnChangeEvent(e.target.checked ? 1 : 0, 'clearAudit')
              }
            />
          </div>
        </div>
      )}
      {!fullScreenView && (
        <div className="row">
          <div className="col-6 col-sm-6 mb-3">
            <RadioGroupComponent
              labelName={selectByLabel}
              id="selectBy"
              data-testid="selectBy"
              required={false}
              defaultValue={searchData && searchData.selectBy}
              filterAction={(e) => {
                handleOnChangeEvent(e, 'selectBy');
              }}
              optionList={[
                {
                  name: 'Labeler',
                  value: 'L',
                  disabled: searchData?.myAuditOnly === 1,
                },
                {
                  name: 'NDC',
                  value: 'NDC',
                  disabled: searchData?.myAuditOnly === 1,
                },
                {
                  name: 'Select All For Above Criteria',
                  value: 'A',
                },
              ]}
            />
          </div>
          <div className="col-6 col-sm-6 mb-3">
            <div className="row">
              <div className="col-6 col-sm-12">
                <RadioGroupComponent
                  labelName={auditTypeLabel}
                  className="mandatory"
                  data-testid="planContract"
                  id="planContract"
                  required
                  reqColor
                  defaultValue={searchData && searchData.auditType}
                  filterAction={(e) => {
                    handleOnChangeEvent(e, 'auditType');
                  }}
                  optionList={[
                    { name: 'All', value: 'ALL' },
                    {
                      name: 'Group',
                      value: 'GRP',
                    },
                    {
                      name: 'Specific',
                      value: 'SPC',
                    },
                  ]}
                />
              </div>
              <div className="col-6 d-flex align-items-center">
                {searchData?.auditType === 'GRP' && (
                  <div className="d-flex flex-column">
                    <FormControlLabel
                      className="ml-0"
                      data-testid="checked_ia4"
                      control={<Checkbox color="primary" className="mr-2" />}
                      label={amountAuditLabel}
                      value={searchData?.amountAudit}
                      checked={searchData?.amountAudit}
                      onChange={(e) => {
                        handleOnChangeEvent(
                          e.target.checked ? 1 : 0,
                          'amountAudit'
                        );
                      }}
                    />
                    <FormControlLabel
                      className="ml-0"
                      data-testid="checked_ia5"
                      control={<Checkbox color="primary" className="mr-2" />}
                      label={unitConversionAuditsLabel}
                      value={searchData?.unitConversionAudit}
                      checked={searchData?.unitConversionAudit}
                      onChange={(e) => {
                        handleOnChangeEvent(
                          e.target.checked ? 1 : 0,
                          'unitConversionAudit'
                        );
                      }}
                    />
                    <FormControlLabel
                      className="ml-0 "
                      data-testid="checked_ia6"
                      control={<Checkbox color="primary" className="mr-2" />}
                      label={otherAuditsLabel}
                      value={searchData?.otherAudit}
                      checked={searchData?.otherAudit}
                      onChange={(e) => {
                        handleOnChangeEvent(
                          e.target.checked ? 1 : 0,
                          'otherAudit'
                        );
                      }}
                    />
                  </div>
                )}
                {searchData?.auditType === 'SPC' && (
                  <div className="mui-custom-form with-select mt-0 w-25" id="">
                    <TextField
                      data-testid="specific-audit-type-dropdown"
                      id="speAuditType"
                      className={
                        getErrorMsg?.searchScreenErrors?.length > 0
                          ? _.map(getErrorMsg?.searchScreenErrors, (l) =>
                              l.field === 'speAuditType'
                                ? 'mandate-fields'
                                : null
                            )
                          : null
                      }
                      fullWidth
                      select
                      placeholder=""
                      label="Selected Audit Type"
                      inputProps={{ maxLength: 11, id: 'speAuditType' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onBlur={(e) =>
                        handleOnblurEvent('speAuditType', e.target.value)
                      }
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'speAuditType')
                      }
                      value={
                        searchData && searchData.speAuditType
                          ? searchData.speAuditType
                          : ''
                      }
                      error={
                        getErrorMsg?.searchScreenErrors?.length > 0
                          ? _.map(getErrorMsg?.searchScreenErrors, (l) =>
                              l.field === 'speAuditType' ? l.message : null
                            )
                          : null
                      }
                      helperText={
                        getErrorMsg?.searchScreenErrors?.length > 0
                          ? _.map(getErrorMsg?.searchScreenErrors, (l) =>
                              l.field === 'speAuditType' ? l.message : null
                            )
                          : null
                      }
                    >
                      <MenuItem
                        key=""
                        value=""
                        className="frr-dropdown-blank-item"
                      />
                      {specificAuditTypeList &&
                      specificAuditTypeList.length &&
                      specificAuditTypeList.length > 0
                        ? specificAuditTypeList.map((item) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="row">
        {searchData?.selectBy === 'L' && (
          <div className="col-sm-12">
            <TableGridWithFeatures
              data-testid="claim-audit-labeler-component-grid"
              rowSelection="single"
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
              gridCall={onGridReady}
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              exportFile
              animateRows
              sideBar={false}
              fileName={labelerGridFileName}
              columnDefs={SelectByLabelerColoumData}
              rowData={labelerListDataList}
              cellClickedListener={(e) => onClickOnViewClaimDetail(e.data)}
            />
          </div>
        )}
        {searchData?.selectBy === 'NDC' && (
          <div className="col-sm-12">
            <SearchTypeComponent
              id="claimAuditSelect"
              data-testid="claim-audit-select-Ndc-Component"
              viewDetailButtonName={viewClaimDetailButton}
              searchType={searchType}
              setSearchType={setSearchType}
              getErrorsFromSearchTypeComponent={
                getErrorsFromSearchTypeComponent
              }
              errorMsgFromSearchType={errorMsgFromSearchType}
              setLabelerFullScreen={setLabelerFullScreen}
              labelerFullScreen={labelerFullScreen}
              setNdcLeftFullScreen={setNdcLeftFullScreen}
              ndcLeftFullScreen={ndcLeftFullScreen}
              setNdcRightFullScreen={setNdcRightFullScreen}
              ndcRightFullScreen={ndcRightFullScreen}
              handleViewDetailFunction={onClickOnViewClaimDetail}
              setlabelerSelectedRow={setlabelerSelectedRow}
              labelerSelectedRow={labelerSelectedRow}
              setNdcLeftSelectedRows={setNdcLeftSelectedRows}
              ndcLeftSelectedRows={ndcLeftSelectedRows}
              setNdcRightSelectedRows={setNdcRightSelectedRows}
              ndcRightSelectedRows={ndcRightSelectedRows}
              setlabelerTableData={setlabelerTableData}
              labelerTableData={labelerTableData}
              setNdcLeftTableData={setNdcLeftTableData}
              ndcLeftTableData={ndcLeftTableData}
              setNdcRightTableData={setNdcRightTableData}
              ndcRightTableData={ndcRightTableData}
              setNdcSearchVal={setNdcSearchVal}
              ndcSearchVal={ndcSearchVal}
              setNdcNameSearchVal={setNdcNameSearchVal}
              ndcNameSearchVal={ndcNameSearchVal}
            />
          </div>
        )}
      </div>
      {!fullScreenView && (
        <div className="d-flex justify-content-end">
          {searchData?.selectBy === 'NDC' || searchData?.selectBy === 'L' ? (
            ''
          ) : (
            <div className="m-4 btn-wrapper">
              <Button
                className="btn-success same-font-family frr-btn-width-17 mt-4"
                data-testid="view-claim-detail"
                type="button"
                onClick={() => {
                  if (
                    !getErrorMsg?.searchScreenErrors?.filter((x) => {
                      return x.field !== 'claimAuditDetailscr';
                    }).length > 0
                  ) {
                    onClickOnViewClaimDetail();
                  } else {
                    handleScrollToEvent();
                  }
                }}
              >
                <SVGComponent iconName="Icon-view" />
                &nbsp; {viewClaimDetailButton}
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ClaimAuditSelect;
